export default "/assets/images/chart-05.8d3c7564830651db.svg";